// Data plans (his ruling and prices, 28 Oct 2026). The server's copy of the prices is
// supabase/functions/_shared/data-plans.ts and is the one that charges; these are for showing only,
// and scripts/test-data-plans/run.ts checks the two are the same.

// No prices on any page until checkout works (22 Oct rule). Off = the plans show what they include,
// with no price and no checkout. Turned on only after the test purchases pass and he says go.
const OPEN = true;
// Local preview only: `VITE_DATA_PLANS_PREVIEW=1 npx vite` shows the prices and checkout on this machine.
// A production build (import.meta.env.DEV false) can never open them this way.
const env = (import.meta as unknown as { env?: Record<string, unknown> }).env;
export const PREVIEW = !!env?.DEV && env?.VITE_DATA_PLANS_PREVIEW === "1";
export const PLANS_OPEN = OPEN || PREVIEW;

// The Data API (step 3, his ruling 29 Oct 2026: the API first, then prices). Off = the pages call it in
// development and the account page offers keys to admins only (for the live check). On once all 7 addresses
// answer live with a real key. The API itself answers either way; this only changes what the pages say.
export const API_OPEN = true;
const soon = API_OPEN ? "" : " when it opens";

export type PlanId = "individual" | "professional";
export type Period = "monthly" | "annual";

export const PRICES: Record<PlanId, { USD: Record<Period, number>; INR: Record<Period, number> }> = {
  individual: { USD: { monthly: 19, annual: 190 }, INR: { monthly: 1499, annual: 14999 } },
  professional: { USD: { monthly: 49, annual: 490 }, INR: { monthly: 3999, annual: 39999 } },
};

// Rupee mandates stop at ₹15,000 a debit, so the yearly rupee plans (over it with GST) are paid once for
// the year or by a bank-account mandate (his ruling, 29 Oct 2026). Off would show readers in India monthly only.
export const INR_YEARLY_OPEN = true;

export const PLANS: { id: "free" | PlanId; name: string; who: string; includes: string[] }[] = [
  {
    id: "free",
    name: "Free",
    who: "Anyone reading for their own research",
    includes: [
      "The last 5 years on every company page",
      "10 downloads a month with a free account",
      `The API at 250 calls a day${soon}`,
      "Quote it with credit and a link",
    ],
  },
  {
    id: "individual",
    name: "Individual",
    who: "One person researching for themselves",
    includes: [
      "Every year back to the first filing, on every page",
      "Unlimited Excel, Google Sheets, CSV and JSON downloads",
      `The API at 300 calls a minute${soon}`,
      "For your own research",
    ],
  },
  {
    id: "professional",
    name: "Professional",
    who: "Analysts, advisers and funds using it at work",
    includes: [
      "Everything in Individual",
      "Use the data at work, inside one firm, including research for your clients",
      API_OPEN ? "The API at 1,000 calls a minute, and bulk files when they open" : "Bulk files and higher API limits when they open",
      "Putting the data inside an app or product, or reselling it? Tell us and we'll agree a licence",
    ],
  },
];

export const LAUNCH_NOTE = API_OPEN
  ? "These are launch prices. They go up as coverage grows past 3,000 companies, and anyone who joins before then keeps the price they joined at."
  : "These are launch prices. They go up as the API opens and coverage grows past 3,000 companies, and anyone who joins before then keeps the price they joined at.";
